<template>
  <div
    v-if="shouldShowBanners"
    class="account-mapping-banners__outer-container"
  >
    <sf-banner-page
      v-for="banner in processedBanners"
      :key="banner.id"
      :title="banner.title"
      :variant="banner.variant"
      :show-close="banner.showClose"
      :has-long-text="Array.isArray(banner.description)"
      is-full-width
      @close="dismissBanner(banner.id)"
    >
      <div v-for="descriptionLine in banner.description" :key="descriptionLine">
        {{ descriptionLine }}
      </div>
      <template #link>
        <a :href="banner.url">{{ banner.linkText }}</a>
      </template>
    </sf-banner-page>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia'

import SfBannerPage from '@app/shared/vue/components/sf-banner/sf-banner-page.vue'
import { useBannerManager } from '@app/shared/pinia/banner-manager'

export default {
  components: {
    SfBannerPage,
  },
  computed: {
    ...mapState(useBannerManager, ['activeBanners']),
    shouldShowBanners() {
      return Object.keys(this.activeBanners).length > 0
    },
    processedBanners() {
      return Object.values(this.activeBanners).map((banner) => ({
        ...banner,
        description: [banner.description].flat(),
      }))
    },
  },
  methods: {
    ...mapActions(useBannerManager, ['dismissBanner']),
  },
}
</script>

<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.account-mapping-banners {
  &__outer-container {
    @include background-color('white');

    display: flex;
    border-bottom: 1px solid -color('snow', 'dark');
  }
}
</style>
